// extracted by mini-css-extract-plugin
export default {"dropdownToggle":"dropdownToggle_dropdownToggle__Pznqo"};